var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"subtitle-2 my-3"},[_vm._v("Remind")]),_c('v-btn',{on:{"click":function($event){return _vm.remind()}}},[_vm._v("Remind")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }